import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {ContentType} from '@deezer/next/services/types/contentType';
import type {OfferType} from '@deezer/next/services/api/Starmania/requests/album/types';
import type {
	AnalyticContexts,
	AnalyticOverview,
	AnalyticTimeseries,
	AnalyticTopArtists,
	AnalyticTopTracks,
	AnalyticTrendingArtists,
	AnalyticTrendingTracks,
	AlbumContentData,
	PlaylistDataResponse,
} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';

const {post, get} = requestWrapper;

const requests = {
	getPlaylistData: (playlistId: number) => {
		const body = new FormData();
		body.append('action', 'getPlaylistData');
		body.append(
			'params',
			JSON.stringify([
				{
					playlistId,
				},
			]),
		);
		return post<PlaylistDataResponse>(endpoints.ajax, body, {
			headers: {
				'Content-Type': 'multipart/form-data',
				'x-requested-with': 'xmlhttprequest',
			},
		});
	},
	view: (country: string) => {
		const body = new FormData();
		body.append('action', 'POST');
		body.append('params', JSON.stringify({country}));
		return post<AnalyticOverview>(endpoints.view, body, {
			headers: {
				'Content-Type': 'multipart/form-data',
				'x-requested-with': 'xmlhttprequest',
			},
		});
	},
	getContentData: (
		type: ContentType.Album,
		id: string,
		payload: {
			[key: string]: string;
			country: string;
			service: OfferType;
			dateTo: string;
			dateFrom: string;
		},
	) => {
		const body = new FormData();
		body.append('action', 'POST');
		body.append('params', JSON.stringify(payload));
		return post<AlbumContentData>(endpoints.contentData(type, id), body, {
			headers: {
				'Content-Type': 'multipart/form-data',
				'x-requested-with': 'xmlhttprequest',
			},
		});
	},

	getTopArtists: (country: string) =>
		get<DataResponseWrapper<AnalyticTopArtists>>(endpoints.topArtists, {
			params: {
				country,
			},
		}),
	getTopTracks: (country: string) =>
		get<DataResponseWrapper<AnalyticTopTracks>>(endpoints.topTracks, {
			params: {
				country,
			},
		}),
	getTrendingArtists: (country: string) =>
		get<DataResponseWrapper<AnalyticTrendingArtists>>(
			endpoints.trendingArtists,
			{
				params: {
					country,
				},
			},
		),
	getTrendingTracks: (country: string) =>
		get<DataResponseWrapper<AnalyticTrendingTracks>>(endpoints.trendingTracks, {
			params: {
				country,
			},
		}),
	getTimeseries: (filters: {
		country: string;
		dateFrom: string;
		dateTo: string;
	}) =>
		get<DataResponseWrapper<AnalyticTimeseries>>(endpoints.timeseries, {
			params: filters,
		}),
	getContexts: (country: string) =>
		get<DataResponseWrapper<AnalyticContexts>>(endpoints.contexts, {
			params: {
				country,
			},
		}),
};

export default requests;
